import { Plus } from "lucide-react";

import { withForm } from "~/components/form/app-form";
import { ArrayItemCard } from "~/components/form/fields/array-item-card";
import { Button } from "~/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const ProgramSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>About the Program (practical details)</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.AppField name="programHeadline">
            {(field) => <field.TextField label="Program Headline" />}
          </form.AppField>

          <form.AppField name="programDescription">
            {(field) => (
              <field.TextareaField
                label="Program Description"
                maxLength={500}
              />
            )}
          </form.AppField>

          <form.AppField name="programImageUrl">
            {(field) => (
              <field.ImageField
                purpose="offer"
                label="Image to show in the program overview section"
                helpText="(300x200)"
              />
            )}
          </form.AppField>

          <h3 className="font-heading text-lg text-primary">
            Program components / parts
          </h3>

          <form.Field name="components" mode="array">
            {(arrayField) => (
              <>
                {(arrayField.state.value ?? []).map((item, i) => (
                  <ArrayItemCard
                    key={i}
                    index={i}
                    isFirst={i === 0}
                    isLast={i === (arrayField.state.value?.length ?? 0) - 1}
                    isDeleted={item._delete === true}
                    itemLabel="component"
                    onMoveUp={() => arrayField.moveValue(i, i - 1)}
                    onMoveDown={() => arrayField.moveValue(i, i + 1)}
                    onToggleDelete={() =>
                      form.setFieldValue(
                        `components[${i}]._delete`,
                        !item._delete,
                      )
                    }
                  >
                    <form.AppField name={`components[${i}].preHeader`}>
                      {(field) => <field.TextField label="Pre-Header" />}
                    </form.AppField>
                    <form.AppField name={`components[${i}].title`}>
                      {(field) => <field.TextField label="Title" required />}
                    </form.AppField>
                    <form.AppField name={`components[${i}].imageUrl`}>
                      {(field) => (
                        <field.ImageField
                          purpose="offer"
                          label="Image"
                          recommendedDimensions={{ width: 600, height: 400 }}
                        />
                      )}
                    </form.AppField>
                    <form.AppField name={`components[${i}].content`}>
                      {(field) => (
                        <field.TextareaField label="Content" maxLength={500} />
                      )}
                    </form.AppField>
                  </ArrayItemCard>
                ))}
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() =>
                    arrayField.pushValue({
                      preHeader: "",
                      title: "",
                      content: "",
                      imageUrl: "",
                      order: arrayField.state.value?.length ?? 0,
                      _delete: false,
                    })
                  }
                >
                  <Plus className="mr-2 h-4 w-4" /> Add Component
                </Button>
              </>
            )}
          </form.Field>
        </CardContent>
      </Card>
    );
  },
});
